"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightTimeSpanUnit = exports.HighlightEventType = exports.HighlightType = exports.HighlightEntityType = void 0;
var HighlightEntityType;
(function (HighlightEntityType) {
    HighlightEntityType["Task"] = "TASK";
    HighlightEntityType["PullRequest"] = "PULL_REQUEST";
})(HighlightEntityType = exports.HighlightEntityType || (exports.HighlightEntityType = {}));
var HighlightType;
(function (HighlightType) {
    HighlightType["Insight"] = "INSIGHT";
    HighlightType["Event"] = "EVENT";
    HighlightType["Property"] = "PROPERTY";
    HighlightType["PropertyCount"] = "PROPERTY_COUNT";
})(HighlightType = exports.HighlightType || (exports.HighlightType = {}));
var HighlightEventType;
(function (HighlightEventType) {
    HighlightEventType["PropertyChange"] = "PROPERTY_CHANGE";
    HighlightEventType["PropertyChangeCount"] = "PROPERTY_CHANGE_COUNT";
    HighlightEventType["PropertyChangeDuringStatus"] = "PROPERTY_CHANGE_DURING_STATUS";
})(HighlightEventType = exports.HighlightEventType || (exports.HighlightEventType = {}));
var HighlightTimeSpanUnit;
(function (HighlightTimeSpanUnit) {
    HighlightTimeSpanUnit["HOUR"] = "Hour";
})(HighlightTimeSpanUnit = exports.HighlightTimeSpanUnit || (exports.HighlightTimeSpanUnit = {}));
//# sourceMappingURL=highlights.js.map